var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"download-container-scrollable pa-0"},[(!_vm.downloadIsAvailable && !_vm.activeLayers.length)?_c('v-row',[_c('v-col',{staticClass:"pa-8"},[_c('v-alert',{attrs:{"dense":"","outlined":"","type":"info"}},[_vm._v(" "+_vm._s(_vm.$t('noLayersSelected'))+" ")])],1)],1):[(_vm.showApiTab)?_c('v-tabs',{attrs:{"fixed-tabs":""},on:{"change":_vm.handleTabChange}},[_c('v-tab',{attrs:{"to":{
          name: 'download.geoserver'
        }}},[_vm._v(" Geoserver ")]),_c('v-tab',{attrs:{"to":{
          name: 'download.api'
        }}},[_vm._v(" API ")])],1):_vm._e(),_c('router-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }